import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA9buimmKHt9vxcXLQFtsd-7Oa3WoGy8oQ",
  authDomain: "s3e-lisencing-server.firebaseapp.com",
  projectId: "s3e-lisencing-server",
  storageBucket: "s3e-lisencing-server.firebasestorage.app",
  messagingSenderId: "91762018489",
  appId: "1:91762018489:web:9ed921e00381de7f82b368",
  measurementId: "G-MWSG4ZGLGZ"
};

// API Configuration
export const API_CONFIG = {
  baseURL: 'https://license.s3e.nl',
  endpoints: {
    admin: '/admin',
    license: '/license',
    health: '/health'
  }
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

export default app; 